import * as React from 'react';

import {
  Button,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@rematter/ui-web';
import { Trash2 } from 'lucide-react';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

interface VoidPurchaseOrderDialogProps {
  purchaseOrderId: string;
  onVoid: (purchaseOrderId: string) => Promise<void>;
  onCancel?: () => void;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const VoidPurchaseOrderDialog: React.FC<
  VoidPurchaseOrderDialogProps
> = ({
  purchaseOrderId,
  onVoid,
  onCancel,
  message,
  confirmLabel,
  cancelLabel,
}) => {
  const t = useTranslations();
  const [isLoading, setIsLoading] = React.useState(false);

  const i18nMessage = message ?? t.voidPurchaseOrderDialog.message(1);
  const i18nConfirm = confirmLabel ?? t.voidPurchaseOrderDialog.confirm;
  const i18nCancel = cancelLabel ?? t.voidPurchaseOrderDialog.cancel;
  const i18nTitle = t.voidPurchaseOrderDialog.title(1);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      await onVoid(purchaseOrderId);
    } catch (error) {
      console.error('Error voiding purchase order:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogOverlay isOpen className="@VoidPurchaseOrderDialog">
      <DialogContent>
        <DialogHeader>
          <div className="text-base font-semibold">{i18nTitle}</div>
        </DialogHeader>
        <div className="flex flex-col gap-2 px-4">
          <div className="text-base text-neutral/50">{i18nMessage}</div>
          <div className="flex justify-end gap-2 py-4">
            <Button variant="text" color="neutral" onPress={onCancel}>
              {i18nCancel}
            </Button>
            <Button
              variant="solid"
              color="failure"
              onPress={handleConfirm}
              icon={<Trash2 className="size-4" />}
              isDisabled={isLoading}
            >
              {i18nConfirm}
            </Button>
          </div>
        </div>
      </DialogContent>
    </DialogOverlay>
  );
};
